import { useCallback, useState } from 'react';
import type { LegendDisplayMode } from '../types';

interface UseLegendDisplayModeArgs {
  defaultMode?: LegendDisplayMode;
  controlledValue?: LegendDisplayMode;
  onChange?: (mode: LegendDisplayMode) => void;
}

interface UseLegendDisplayModeResult {
  mode: LegendDisplayMode;
  setMode: (mode: LegendDisplayMode) => void;
  toggle: () => void;
}

export const useLegendDisplayMode = ({
  defaultMode = 'axis',
  controlledValue,
  onChange,
}: UseLegendDisplayModeArgs): UseLegendDisplayModeResult => {
  const [internalMode, setInternalMode] =
    useState<LegendDisplayMode>(defaultMode);
  const mode = controlledValue ?? internalMode;

  const setMode = useCallback(
    (next: LegendDisplayMode) => {
      if (controlledValue === undefined) setInternalMode(next);
      onChange?.(next);
    },
    [controlledValue, onChange],
  );

  const toggle = useCallback(() => {
    setMode(mode === 'axis' ? 'legend' : 'axis');
  }, [mode, setMode]);

  return { mode, setMode, toggle };
};
